module.exports = __webpack_public_path__ + "img/wordpress@2x.9c05aab5.png";